export default __webpack_public_path__ + "static/media/twevelPieces7.e5c935e5.jpg";